(() => {
  const marker = Symbol.for('minicubez.cart-return');
  if (window[marker]) return;
  window[marker] = true;
  const configuredRoot = document.currentScript?.dataset.mcRoot || '/';
  const root = configuredRoot.startsWith('/') && !configuredRoot.startsWith('//') ? configuredRoot : '/';
  let revision = 0;
  let pending = false;
  let controller;
  const invalidate = () => { revision += 1; controller?.abort(); };
  document.addEventListener('change', event => {
    if (event.target.closest?.('cart-items,cart-drawer-items,mc-cart-group')) invalidate();
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.matches?.('form[action*="/cart"]')) invalidate();
  }, true);
  document.addEventListener('cart:updated', invalidate);
  window.addEventListener('pageshow', async event => {
    if (!event.persisted || pending) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer?.getSectionsToRender || !drawer.close) return;
    const sections = drawer.getSectionsToRender();
    if (!sections.length || sections.length > 5 || sections.some(section => !/^[a-z0-9-]+$/.test(section.id))) return;
    pending = true;
    const current = revision;
    controller = new AbortController();
    try {
      const response = await fetch(root + '?sections=' + encodeURIComponent(sections.map(section => section.id).join(',')), { cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('cart-return');
      const payload = await response.json();
      const updates = sections.map(section => {
        if (typeof payload[section.id] !== 'string') throw new Error('cart-return');
        const parsed = new DOMParser().parseFromString(payload[section.id], 'text/html');
        const source = parsed.querySelector(section.selector || '.shopify-section');
        const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if (!source || !target) throw new Error('cart-return');
        return { source, target, drawer: parsed.querySelector('cart-drawer') };
      });
      if (current !== revision || !drawer.isConnected) return;
      const focused = drawer.contains(document.activeElement);
      const scrollTop = drawer.querySelector('.drawer__inner')?.scrollTop || 0;
      for (const update of updates) update.target.innerHTML = update.source.innerHTML;
      const sourceDrawer = updates.find(update => update.drawer)?.drawer;
      if (sourceDrawer) drawer.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
      drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
      const inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.scrollTop = scrollTop;
      if (drawer.classList.contains('active')) {
        if (typeof window.trapFocus === 'function') window.trapFocus(inner, focused ? inner?.querySelector('.drawer__close') : undefined);
        else if (focused) inner?.querySelector('.drawer__close')?.focus({ preventScroll: true });
      }
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('[MiniCubez cart] MC_CART_RETURN_REFRESH_FAILED');
    } finally {
      pending = false;
      controller = null;
    }
  });
})();
